import Modal from "@/components/Modal";

import "./style.css";

export default class RequestInfoModal extends Modal {
  static selector = ".request-info-modal";

  constructor(block) {
    super(block);

    this.block = block;

    this.subtitle = this.block.querySelector('.modal__subtitle');
  }

  // Lifecycle methods
  onReady() {}
  modalDidMount = async () => {};
  modalWillOpen = async () => {};
  modalDidUpdate = async ({ whatever }) => {};
  modalDidClose = async () => {};
  onDestroy() {}
}
